import React from 'react'
import BaseIcon from 'react-icon-base'

const PK = props => (
  <BaseIcon width={21} height={15} viewBox="-75 -40 120 80" {...props}>
    <title>Flag of Pakistan</title>
    <rect x="-75" y="-40" width="120" height="80" fill="#fff" />
    <rect x="-45" y="-40" width="90" height="80" fill="#01411C" />
    <circle r="24" fill="#fff" />
    <circle r="22" cx="-7" cy="-40" fill="#01411C" transform="rotate(-41.63354, 45, -40)" />
    <polygon
      points="0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571"
      fill="#fff"
      transform="rotate(-41.63354) translate(16) rotate(18) scale(0.00001557408)"
    />
  </BaseIcon>
)

export default PK
